<template>
  <div>
    <b-row>
      <b-col>
        <h3 class="mb-2">
          Ongoing declarations
        </h3>
      </b-col>
    </b-row>
    <b-row class="unfinished-declaration-cards">
      <declaration-card
        v-for="statCard in statistics"
        :key="statCard.title"
        :title="statCard.title"
        :amount="statCard.stat"
        :loading="statCard.loading"
        :icon="statCard.icon"
        :class-name="statCard.className"
      />
    </b-row>
  </div>
</template>

<script>
import { BCol, BRow } from 'bootstrap-vue'
import { parseFilters, searchQuery } from '@core/utils/filter'
import { EventBus } from '@core/utils/utils'
import DeclarationCard from '@/views/dashboard/components/DeclarationCard.vue'

export default {
  components: {
    BCol,
    DeclarationCard,
    BRow,
  },
  data() {
    return {
      statistics: {
        withoutDeclaration: {
          icon: 'BoxIcon',
          title: 'Not sent to customs',
          loading: false,
          className: '',
          stat: 0,
        },
        waitingForCustoms: {
          icon: 'ClockIcon',
          title: 'Waiting for customs',
          loading: false,
          className: 'text-primary',
          stat: 0,
        },
        waitingForArrival: {
          icon: 'TruckIcon',
          title: 'Waiting for arrival',
          loading: false,
          className: 'text-primary',
          stat: 0,
        },
        needsAttention: {
          icon: 'XOctagonIcon',
          title: 'Needs attention',
          loading: false,
          className: 'text-warning',
          stat: 0,
        },
        needsDocuments: {
          icon: 'XOctagonIcon',
          title: 'Needs documents',
          loading: false,
          className: 'text-warning',
          stat: 0,
        },
        heldByCustoms: {
          icon: 'PauseCircleIcon',
          title: 'Held by customs',
          loading: false,
          className: 'text-warning',
          stat: 0,
        },
        availableForReadyForLastMile: {
          icon: 'PackageIcon',
          title: 'Available for last mile',
          loading: false,
          className: 'text-success',
          stat: 0,
        },
      },
      selectedDeclaration: null,
      selectedParcel: null,
    }
  },
  computed: {
    isStatsLoading() {
      return Object.values(this.statistics).some(stat => stat.loading === true)
    },
    filter() {
      return parseFilters()
    },
  },
  mounted() {
    this.reFetchData()
    EventBus.$on('companyListUpdated', this.reFetchData)
  },
  beforeDestroy() {
    EventBus.$off('companyListUpdated', this.reFetchData)
  },
  methods: {
    fetchData(status) {
      this.searchFilters = { ...this.filters, status: status }
      this.statistics[status].loading = true
      this.$http.get(searchQuery(`/v1/companies/${this.$activeCompany().data.company.id}/declarations/unfinished-statistics`, this.searchFilters))
        .then(response => {
          this.statistics[status].stat = response.data.data[status]
          this.statistics[status].loading = false
        })
    },
    reFetchData() {
      this.filters = parseFilters()
      Object.keys(this.statistics).forEach(key => {
        this.fetchData(key)
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
